import i18n from 'es2015-i18n-tag';
import React from 'react';
import Tab from '../../../../common/ui-components/tabs/tab.component';
import Tabs from '../../../../common/ui-components/tabs/tabs.component';
import AccountTeamList from './teams/account-team-list.component';
import AccountUserList from './users/account-user-list.component';
import { AccountOverview } from '../account-overview/account-overview.component';
import FetchAccount from '../../resolver/fetch-account.component';
import './view-account.component.scss';
import { useParams } from 'react-router';

const ViewAccount = () => {
    const { accountId } = useParams();

    return (
        <div className="view-account">
            <FetchAccount>{account => <AccountOverview account={account} />}</FetchAccount>
            <Tabs className="view-account__tabs">
                <Tab header={i18n`Teams`}>
                    <AccountTeamList accountId={accountId} />
                </Tab>
                <Tab header={i18n`Users`}>
                    <AccountUserList accountId={accountId} />
                </Tab>
            </Tabs>
        </div>
    );
};

export default ViewAccount;
